module.exports = __webpack_public_path__ + "static/img/ewm.bf2ae65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ewm.png
// module id = PNRf
// module chunks = 1